import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getEducationalHealthRequest: ['response'],
    getEducationalHealthSuccess: ['response'],
    getEducationalHealthFailure: ['error'],
})

export const getEducationalHealthTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const getEducationalHealthRequest = state => {
    return state.merge({ success: null })
}

const getEducationalHealthSuccess = (state, { response }) => {
    return state.merge({
        success: true,
        error: false,
        response: response.data,
    })
}

const getEducationalHealthFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_EDUCATIONAL_HEALTH_REQUEST]: getEducationalHealthRequest,
    [Types.GET_EDUCATIONAL_HEALTH_SUCCESS]: getEducationalHealthSuccess,
    [Types.GET_EDUCATIONAL_HEALTH_FAILURE]: getEducationalHealthFailure,
})
